import { Field, useFormikContext } from 'formik';
import {
  Autocomplete,
  AutocompleteRenderInputParams
} from 'formik-material-ui-lab';
import { FC } from 'react';
import { TextField as TextFieldMaterial } from '@material-ui/core';

type Props = {
  name: string;
  className?: string;
  placeholder?: string;
  fullWidth?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  variant?: 'outlined' | 'filled' | 'standard';
  disabled?: boolean;
  inputHeight?: string;
};

const requiredBillOptions = [
  { value: 'true', label: 'Sí' },
  { value: 'false', label: 'No' }
];

const RequiredBillSelector: FC<Props> = ({
  name,
  className,
  placeholder = 'Factura requerida',
  fullWidth = true,
  margin = 'dense',
  variant = 'outlined',
  disabled,
  inputHeight
}) => {
  const { touched, errors, setFieldValue } = useFormikContext<any>();

  const getOptionLabel = (option: any) => {
    if (typeof option === 'string') {
      const found = requiredBillOptions.find((opt) => opt.value === option);
      return found ? found.label : option;
    }
    return option?.label || '';
  };

  const isOptionEqualToValue = (option: any, value: any) => {
    if (typeof option === 'string' && typeof value === 'string') {
      return option === value;
    }
    return option?.value === value?.value;
  };

  return (
    <div className="relative">
      <Field
        component={Autocomplete}
        name={name}
        options={requiredBillOptions}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextFieldMaterial
            {...params}
            label={placeholder}
            variant={variant}
            fullWidth={fullWidth}
            margin={margin}
            disabled={disabled}
            error={touched[name] && Boolean(errors[name])}
            helperText={touched[name] && errors[name]}
            style={inputHeight ? { height: inputHeight } : undefined}
          />
        )}
        className={className}
        onChange={(event: any, newValue: any) => {
          setFieldValue(name, newValue?.value || null);
        }}
      />
    </div>
  );
};

export default RequiredBillSelector;